module.exports = __webpack_public_path__ + "img/Gifcard_pacchetto_C.095102c7.jpg";